<div class="row align-items-center mt-3">
  <div class="col-md-auto" style="margin-bottom: 12px; margin-top: 16px;">
    <strong>{{ 'envelope.responsible.labelReview' | translate }}</strong>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="table-responsive table__container">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
            <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
            <th *ngIf="isShowSSN()" scope="col" class="text-left">{{ 'ssn' | translate | uppercase }} </th>
            <th *ngIf="isSendWhatsapp || isSignFreemium" scope="col" class="text-left">{{ 'telephone' | translate | titlecase }}</th>
            <th *ngIf="(!canSendWhatsApp || isSendWhatsapp) || isSignFreemium" scope="col" class="text-left">{{ 'envelope.responsible.sendingByWhatsapp' | translate | titlecase }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let element of responsibles; index as i">
              <td class="text-truncate text-left">{{ element.name }}</td>
              <td class="text-truncate text-left">{{ element.mail | mailObfuscate }}</td>
              <td *ngIf="isShowSSN()" class="text-truncate" style="text-align: left;">{{ setMaskValue(element.ssn) }}</td>
              <td *ngIf="isSendWhatsapp || isSignFreemium" class="text-truncate" style="text-align: left;">{{ (element.phoneNumber || element.obfuscatePhoneNumber) | phoneObfuscate }}</td>
              <td *ngIf="(!canSendWhatsApp || isSendWhatsapp) && !isSignFreemium" align="center">
                <div class="icon-switch-container">
                  <fa-icon *ngIf="!canSendWhatsApp && !isSignFreemium" class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                  <cdx-toggle-switch
                    class="pointerMouse"
                    [disabled]="element.acceptWhatsApp === false || !(element.phoneNumber || element.obfuscatePhoneNumber) || !canSendWhatsApp"
                    [toggledOn]="element.sendWhatsApp"
                    (toggle)="needSendWhatsapp($event, element.id)"
                    (click)="handleToggleClick($event)">
                  </cdx-toggle-switch>
                </div>
              </td>
              <td *ngIf="isSignFreemium" align="center">
                <div class="d-flex justify-content-left">
                  <fa-icon class="fa-fw" [icon]="['fas','crown']"></fa-icon>
                  <div (click)="toastWhatsFree()" class="pointerMouse ml-2">
                    <cdx-toggle-switch [disabled]="true"></cdx-toggle-switch>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
